<form #importForm="ngForm" class="import-clients form-v2">
    <div class="modal-header">
        <h3 class="modal-title">Import Clients from Excel</h3>
    </div>
    <div class="modal-body side-panel-body">
        <div id="wizard" class="swMain">
            <!-- start: WIZARD SEPS -->
            <ul class="margin-0">
                <li (click)="goToStep(1)">
                    <a [ngClass]="{ selected: currentStep >= 1, done: currentStep > 1 }">
                        <div class="stepNumber">1</div>
                        <span class="stepDesc text-small"> Select file </span>
                    </a>
                </li>
                <li (click)="goToStep(2)">
                    <a [ngClass]="{ selected: currentStep >= 2, done: currentStep > 2 }">
                        <div class="stepNumber">2</div>
                        <span class="stepDesc text-small"> Match up where your data should go </span>
                    </a>
                </li>
                <li (click)="goToStep(3)">
                    <a [ngClass]="{ selected: currentStep >= 3, done: currentStep > 3 }">
                        <div class="stepNumber">3</div>
                        <span class="stepDesc text-small"> Select the rows </span>
                    </a>
                </li>
                <li (click)="goToStep(4)">
                    <a [ngClass]="{ selected: currentStep >= 4, done: currentStep > 4 }">
                        <div class="stepNumber">4</div>
                        <span class="stepDesc text-small"> Import clients </span>
                    </a>
                </li>
            </ul>
            <!-- end: WIZARD SEPS -->
            <!-- start: WIZARD STEP 1 -->
            <!-- start: WIZARD STEP 1 -->
            <section class="form-section" [hidden]="currentStep !== 1">
                <div class="form-group row" id="step-1">
                    <div class="wrap-progress">
                        <div class="doc-upload-zone wrap-progress" appDragDrop (fileDropped)="fileBrowseHandler($any($event))">
                            <input
                                legacy-css
                                type="file"
                                #fileDropRef
                                id="fileDropRef"
                                (change)="fileBrowseHandler(fileDropRef.files)"
                                [disabled]="importFile"
                                [accept]="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'" />
                            <i class="icon-ic-file-upload-s2"></i><span>Browse or drop import file here</span>
                        </div>
                        <span class="error-msg" *ngIf="fileError">{{ fileError }}</span>
                    </div>
                </div>
            </section>
            <!-- end: WIZARD STEP 1 -->
            <!-- start: WIZARD STEP 2 -->
            <section class="form-section" [hidden]="currentStep !== 2">
                <div class="form-group row" id="step-2">
                    <h5>Please help us match up where your data should go:</h5>
                    <table class="table table-white">
                        <thead>
                            <tr>
                                <th>Excel Column</th>
                                <th>What it contains</th>
                                <th>Where it should go</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let sourceColumn of sourceColumns; let i = index">
                                <td>{{ sourceColumn.name }}</td>
                                <td>
                                    <ul class="list-unstyled">
                                        <li *ngFor="let item of sourceColumn.samples">{{ item }}</li>
                                    </ul>
                                </td>
                                <td>
                                    <ng-select
                                        class="light"
                                        [ngModelOptions]="{ standalone: true }"
                                        [(ngModel)]="sourceColumn.destination"
                                        [items]="destinationColumns"
                                        placeholder="Select in the list"
                                        [clearable]="true"
                                        [searchable]="true"
                                        appendTo="body"
                                        (change)="destinationChanged()"
                                        bindLabel="name">
                                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                            <div>
                                                <span [ngClass]="{ 'is-required': item.isRequired }">{{ item.name }}</span>
                                                <br />
                                                <small>{{ item.description }}</small>
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                    <div *ngIf="sourceColumn.error">
                                        <span class="error-msg">{{ sourceColumn.error }}</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            <!-- end: WIZARD STEP 2 -->
            <!-- start: WIZARD STEP 3 -->
            <section class="form-section" [hidden]="currentStep !== 3">
                <div class="form-group row" id="step-3">
                    <h5>Please select the rows below to import:</h5>
                    <ngx-datatable
                        #importTable
                        *ngIf="itemRows?.length! > 0"
                        class="material bxt-table"
                        [rowHeight]="30"
                        [rows]="itemRows"
                        [headerHeight]="50"
                        [footerHeight]="50"
                        [scrollbarV]="true"
                        [scrollbarH]="true"
                        [virtualization]="false"
                        [selectionType]="selectionType.checkbox"
                        [selected]="selected"
                        (select)="onSelect($event)">
                        <ngx-datatable-column
                            [width]="30"
                            [sortable]="false"
                            [canAutoResize]="false"
                            [draggable]="false"
                            [resizeable]="false"
                            [headerCheckboxable]="true"
                            [checkboxable]="true"></ngx-datatable-column>
                        <ngx-datatable-column name="Name" prop="Name" *ngIf="isDestinationMapped('Name')">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.Name }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Type" prop="CustomerType" *ngIf="isDestinationMapped('CustomerType')">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.CustomerType }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Address" prop="Address" *ngIf="isDestinationMapped('Address')">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.Address }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="CityTown" prop="CityTown" *ngIf="isDestinationMapped('CityTown')">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.CityTown }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="State" prop="State" *ngIf="isDestinationMapped('State')">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.State }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Postcode" prop="Postcode" *ngIf="isDestinationMapped('Postcode')">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.Postcode }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Phone" prop="Phone" *ngIf="isDestinationMapped('Phone')">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.Phone }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Mobile" prop="Mobile" *ngIf="isDestinationMapped('Mobile')">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.Mobile }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Email" prop="Email" *ngIf="isDestinationMapped('Email')">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.Email }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Contacts" prop="contactCount" *ngIf="isDestinationMapped('contactCount')">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.contactCount }}
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </section>
            <!-- end: WIZARD STEP 3 -->
            <!-- start: WIZARD STEP 4 -->
            <section class="form-section" [hidden]="currentStep !== 5">
                <div class="form-group row">
                    <h5>Please wait while we import your contacts... {{ importCount }} / {{ importTotal }}</h5>
                    <progressbar [value]="importProgress"> </progressbar>
                </div>
            </section>
            <!-- end: WIZARD STEP 4 -->
        </div>
    </div>
    <footer class="modal-footer btn-group-footer new">
        <div class="btn-group-left">
            <button type="button" class="btn-bx-secondary-stroked" (click)="cancel()">Cancel</button>
        </div>
        <div class="btn-group-right">
            <button
                type="button"
                class="btn-bx-primary ml-2"
                (click)="previewMapping()"
                [disabled]="mappingError"
                *ngIf="currentStep === 2">
                Next
            </button>
            <button
                type="button"
                class="btn-bx-primary ml-2"
                (click)="runImport()"
                [disabled]="!selected?.length"
                *ngIf="currentStep === 3">
                Import {{ selected.length }} customer{{ selected.length > 1 ? 's' : '' }}
            </button>
        </div>
    </footer>
</form>
